import { ReactElement } from "react";
import clsx from "clsx";
import ErrorBoundary from "../error-boundary";

import styles from "./avatar.module.scss";
import { AuroraIconProps } from "@aurora/icons-react";
import { SizeProps } from "../sizes";

type Variants = typeof variants;

const variants = {
  cloud: "avatarCloud",
  sky: "avatarSky",
  ocean: "avatarOcean",
  wildfire: "avatarWildfire",
  algae: "avatarAlgae",
  sunlight: "avatarSunlight",
  heatwave: "avatarHeatwave",
};

type AvatarProps = {
  /** Which color family to use for the avatar */
  variant?: keyof Variants;
  /** The icon displayed in the avatar */
  icon: ReactElement<AuroraIconProps>;
  /** Optional extra class(es) */
  className?: string;
} & SizeProps;

const Avatar = ({
  variant = "cloud",
  icon,
  size = "m",
  className,
  ...rest
}: AvatarProps) => {
  const variantClass = variants[variant];

  return (
    <ErrorBoundary>
      <div
        {...rest}
        className={clsx(styles.avatar, styles[variantClass], className)}
      >
        <icon.type {...icon.props} size={size === "m" ? "s" : "m"} />
      </div>
    </ErrorBoundary>
  );
};

Avatar.variants = Object.keys(variants).reduce(
  (obj, key) => ({ ...obj, [key]: key }),
  {}
) as RecordKeys<Variants>;
Avatar.displayName = "Avatar";

export default Avatar;
